module.exports = __webpack_public_path__ + "img/conversation-icon.ae71b4bd.svg";